import { useQuery } from '@tanstack/react-query';
import { IsNpsCampaignAnsweredResponseDto } from '@diritto/common/dataAnalysis/dtos/nps-campaign.response.dto';
import { npsQueryKey } from 'queries/nps/queryKey';
import { NpsCampaignApi } from 'api/ApiHelper';

export const useGetNpsCampaignAnswerQuery = (npsCampaignId?: number, enabled = true) =>
  useQuery<IsNpsCampaignAnsweredResponseDto>({
    queryKey: npsQueryKey.npsCampaignAnswer(npsCampaignId),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => NpsCampaignApi.getIsNpsCampaignAnswered(npsCampaignId!),

    enabled,
    gcTime: 1000 * 60 * 60 * 24,
  });
